import { Chip } from '@mui/material';
import { Icon } from '@livable/saas-react-components';
import React from 'react';

/**
 * Marks bill automation as unreleased.
 *
 * Staff can enter credentials today, but nothing retrieves bills with them yet, so every heading
 * that names the feature carries this. One component rather than a literal per heading: the two
 * call sites are the same feature and must not drift into two different promises.
 */
export const ComingSoonTag = () => /*#__PURE__*/React.createElement(Chip, {
  size: "small",
  label: "Coming soon",
  icon: /*#__PURE__*/React.createElement(Icon, {
    type: "info"
  }),
  variant: "info"
});